import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';

// Replace with your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDOQVSKFLSct6_EjDFG8_TlRoaGPUOBSks",
  authDomain: "markandluth.web.app",
  databaseURL: "https://markandluth-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "markandluth",
  storageBucket: "markandluth.firebasestorage.app",
  messagingSenderId: "128691504495",
  appId: "1:128691504495:web:5b0105c584d7644a94d49a",
  measurementId: "G-H3TXS62DRK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app);

export default app;
